import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const orderNo = params.get("order") || "";
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!orderNo) {
      setState("unknown");
      return;
    }
    api
      .get(`/payments/addpay/status/${orderNo}`)
      .then((r) => {
        const ps = (r.data?.local?.payment_status || "").toLowerCase();
        if (ps === "paid") setState("paid");
        else if (ps === "failed") setState("failed");
        else setState("pending");
      })
      .catch(() => setState("pending"));
  }, [orderNo]);

  const map = {
    loading: { icon: Clock, color: "text-purple-400", title: "Checking payment…", sub: "One moment please." },
    paid: { icon: CheckCircle2, color: "text-emerald-500", title: "Payment Successful! 🦋", sub: "Thank you! Your order is confirmed." },
    pending: { icon: Clock, color: "text-amber-500", title: "Payment Processing", sub: "We're confirming your payment. Your order history will update shortly." },
    failed: { icon: XCircle, color: "text-red-500", title: "Payment Not Completed", sub: "Your order is saved. You can try paying again from your account." },
    unknown: { icon: Clock, color: "text-amber-500", title: "No order reference", sub: "Please check your account for order status." },
  };
  const s = map[state];
  const Icon = s.icon;

  return (
    <div data-testid="payment-result-page" className="mx-auto max-w-xl px-6 py-20 text-center">
      <div className="w-20 h-20 rounded-full bg-purple-50 flex items-center justify-center mx-auto">
        <Icon className={`w-10 h-10 ${s.color}`} />
      </div>
      <h1 className="font-display text-3xl font-bold text-purple-950 mt-6">{s.title}</h1>
      <p className="text-muted-foreground mt-3">{s.sub}</p>
      {orderNo && <p className="mt-2 font-semibold brand-gradient-text">{orderNo}</p>}
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/account" className="px-6 py-3 rounded-full brand-gradient text-white font-semibold">My Orders</Link>
        <Link to="/shop" className="px-6 py-3 rounded-full bg-white border border-purple-200 font-semibold text-purple-800">Continue Shopping</Link>
      </div>
    </div>
  );
}
